import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SEO } from "../components/SEO";

export default function NotFound() {
  return (
    <div className="container notfound" data-testid="not-found-page">
      <SEO title="Page Not Found | CustoRacks" description="The page you're looking for doesn't exist." />
      <span className="sec-label">404</span>
      <h1>Page not found</h1>
      <p>The page you're looking for doesn't exist or has moved.</p>
      <Link to="/" className="btn btn-orange" data-testid="notfound-home-btn">Back to Home <ArrowRight size={15} /></Link>
    </div>
  );
}

export function Legal({ type }) {
  const isPrivacy = type === "privacy";
  return (
    <>
      <SEO title={`${isPrivacy ? "Privacy Policy" : "Terms & Conditions"} | CustoRacks`}
        description={`CustoRacks ${isPrivacy ? "privacy policy" : "terms and conditions"}.`} />
      <section className="page-hero">
        <div className="container">
          <div className="crumbs">Home / {isPrivacy ? "Privacy Policy" : "Terms & Conditions"}</div>
          <h1>{isPrivacy ? "Privacy Policy" : "Terms & Conditions"}</h1>
        </div>
      </section>
      <section className="section">
        <div className="container legal-body">
          {isPrivacy ? (
            <>
              <h2>Information We Collect</h2>
              <p>When you submit an enquiry, we collect the details you provide — name, company, contact details and requirement information — solely to respond to your enquiry and plan your storage solution.</p>
              <h2>How We Use It</h2>
              <p>Your information is used only to communicate with you about your requirement. We do not sell or share your details with third parties for marketing.</p>
              <h2>Contact</h2>
              <p>For any privacy questions, contact us at jafar@custoracks.com.</p>
            </>
          ) : (
            <>
              <h2>General</h2>
              <p>Content on this website is provided for general information about CustoRacks products and services. System designs, capacities and configurations are confirmed individually for each project.</p>
              <h2>Quotations</h2>
              <p>Quotations are prepared against your specific requirement and site conditions, and are shared directly by our team.</p>
              <h2>Contact</h2>
              <p>For any questions about these terms, contact us at jafar@custoracks.com.</p>
            </>
          )}
        </div>
      </section>
    </>
  );
}
